module.exports = __webpack_public_path__ + "7e4b29ba/img/arrow-share-icon.00a12c29.svg";